
















import { Component, Vue } from 'vue-property-decorator';
import I18n from '@/i18n/I18n';
import Language from '@/language/Language';
import LanguageFactory from '@/language/LanguageFactory';
import Location from '@/location/Location';
import LocationContract from '@/location/LocationContract';
import Logo from '@/components/header/Logo.vue';
import Mainnav from '@/components/header/Mainnav.vue';

@Component({
    components: {
        Logo,
        Mainnav,
    },
})
export default class App extends Vue {
    private languageFactory!: LanguageFactory;

    private created(): void {
        this.languageFactory = new LanguageFactory();
    }

    private get currentLanguage(): Language {
        return this.languageFactory.createFrom(I18n);
    }

    private get locations(): Array<LocationContract> {
        return Location.query()
            .withAll()
            .orderBy('theme')
            .orderBy('weight', 'desc')
            .get();
    }
}
